const a = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" role="presentation" aria-hidden="true"><path d="M14.99 5.393A7.3 7.3 0 0 0 12 4.75a7.22 7.22 0 0 0-4.671 1.705 7.3 7.3 0 0 0-1.921 2.523A7.3 7.3 0 0 0 4.75 12a7.25 7.25 0 1 0 14.5 0 .75.75 0 0 1 1.5 0 8.75 8.75 0 1 1-2.5-6.125V3.75a.75.75 0 0 1 1.5 0V8a.75.75 0 0 1-.75.75h-4.25a.75.75 0 0 1 0-1.5h2.727a7.3 7.3 0 0 0-2.487-1.857"/></svg>';
export {
  a as w
};
